/*----------------------------------
- DOMAINING NEWS SUBSCRIBE BAND
----------------------------------*/

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import NewsletterSubscribeForm from '@/client/pages/landing/components/newsletter/NewsletterSubscribeForm';
import { track } from '@/client/pages/landing/lib/analytics';
import type { NewsletterPublicSubscriptionSource } from '@uniquedomains/components/contracts/newsletter/public';

/*----------------------------------
- TYPES
----------------------------------*/

type DomainingNewsSubscribeBandProps = {
    source: NewsletterPublicSubscriptionSource;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/** The ink capture band closing an edition: one heading, one promise, one field row. */
export default function DomainingNewsSubscribeBand({
    source,
}: DomainingNewsSubscribeBandProps) {
    return (
        <div
            class="flex flex-col gap-3 rounded-[22px] bg-[#1b1d1e] px-5 py-[22px] lg:gap-3.5 lg:rounded-[24px] lg:p-7"
            data-testid={`domaining-news-subscribe-band-${source}`}
        >
            <p class="text-pretty text-[23px] font-bold leading-[1.15] tracking-[-0.035em] text-white lg:text-xl lg:leading-[1.2] lg:tracking-[-0.03em]">
                The week in domains, in your inbox on Monday
            </p>
            <p class="max-w-[460px] text-[13.5px] leading-[1.55] text-white/60">
                One email a week. Unsubscribe from the footer of any edition.
            </p>
            {/* The shared form never tracks; the band records the accepted outcome with its source only. */}
            <NewsletterSubscribeForm
                source={source}
                tone="dark"
                size="lg"
                showArrow
                onSubscribed={() => track('newsletter_subscribe_submitted', { source })}
            />
        </div>
    );
}
